export default "__VITE_ASSET__Cv8bWrqw__"